<template>
  <div>
    <personalInfo v-if="show=='personalInfo'" v-on:changePassWord="tochangePassWord"></personalInfo>
    <changePassword v-if="show=='changePassword'" v-on:changePassWord="tochangePassWord"></changePassword>
    <changePhone v-if="show=='changePhone'" v-on:changePassWord="tochangePassWord"></changePhone>
  </div>
</template>
<script>
  import personalInfo from './personal_center/personalInfo'
  import changePassword from './personal_center/changePassword'
  import changePhone from './personal_center/changePhone'
  export default{
    name:'personalCenter',
    data () {
      return {
        show:'personalInfo'
      }
    },
    components:{
      'personalInfo':personalInfo,
      'changePassword':changePassword,
      'changePhone':changePhone
    },
    methods:{
      tochangePassWord:function(data){
        console.log(data);
        this.show=data;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/personalCenter.vue